export const PORTAL_SESSION_EXPIRED_EVENT = 'portal:session-expired';

const AUTH_API_PREFIX = '/api/v1/auth/';

function requestUrl(input: RequestInfo | URL): URL | null {
  try {
    if (input instanceof Request) {
      return new URL(input.url, window.location.href);
    }
    return new URL(String(input), window.location.href);
  } catch {
    return null;
  }
}

export function isProtectedPortalApiRequest(input: RequestInfo | URL): boolean {
  const url = requestUrl(input);
  return Boolean(
    url &&
      url.origin === window.location.origin &&
      url.pathname.startsWith('/api/') &&
      !url.pathname.startsWith(AUTH_API_PREFIX),
  );
}

export function installPortalSessionExpiryInterceptor(): () => void {
  const browserFetch = window.fetch.bind(window);
  const interceptedFetch: typeof window.fetch = async (input, init) => {
    const response = await browserFetch(input, init);
    if (response.status === 401 && isProtectedPortalApiRequest(input)) {
      window.dispatchEvent(new Event(PORTAL_SESSION_EXPIRED_EVENT));
    }
    return response;
  };

  window.fetch = interceptedFetch;

  return () => {
    if (window.fetch === interceptedFetch) {
      window.fetch = browserFetch;
    }
  };
}
